import { Result } from "antd";

export default function GlobalNotFoundPage() {
  return <Result status="404" title="404" subTitle="Sorry, page is not found." />;
}
